import { render } from "./BannerArea.vue?vue&type=template&id=665776da"
import script from "./BannerArea.vue?vue&type=script&lang=js"
export * from "./BannerArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__